<template>
  <div :class="[$style.example_content_item]">
    <core-popup
      v-if="showForm"
      :close-icon="true"
      :show="showForm"
      :title="locale(`${title}`)"
      :width="'396'"
      @onClickCancel="toggleForm"
    >
      <template
        #body
      >
        <div :class="$style.report_form">
          <div :class="$style.report_form_element">
            <vgp-label-slot
              v-if="calculationDropdownItems.length"
              :label="locale(`reports_pages_model_of_calc`)"
              :style="{marginBottom: '16px'}"
            >
              <template #body>
                <vgp-dropdown-select
                  :drop-list="calculationDropdownItems"
                  :highlight-active-state="false"
                  :show-selected-first="false"
                  :show-reset-btn="false"
                  :multiselect="false"
                  track-by-item-tooltip="tooltip"
                  group-by="group"
                  item-template="text"
                  track-by-text="text"
                  size="autoWidth"
                  :selected="calculationMode"
                  @selected="changeCalculationMode"
                />
              </template>
            </vgp-label-slot>
            <vgp-label-slot :label="hasPortfoliosTab ? locale(`report_form_select_projects_or_multiview`) : locale(`report_form_select_projects`)">
              <template #body>
                <div
                  v-if="hasPortfoliosTab"
                  :class="$style.reports_form_tabs"
                >
                  <vgp-tabs
                    :tabs="tabsItems"
                    :active="activeFormTab"
                    type="button"
                    @onToggle="toggleTab"
                  />
                </div>

                <div v-if="activeFormTab.id === 1">
                  <vgp-dropdown-select
                    ref="selectedProjects"
                    :placeholder="locale('reports_pages_projects_dropdown_placeholder')"
                    :class="[$style.vgp_select]"
                    :highlight-active-state="false"
                    :use-search="true"
                    :show-selected-first="true"
                    :show-reset-btn="false"
                    :selected="selectedProjects"
                    :drop-list="projects"
                    item-template="text"
                    :use-select-all="hasMultiSelect"
                    :multiselect="hasMultiSelect"
                    track-by-text="name"
                    class="dropdown"
                    :size="'autoWidth'"
                    :need-description="false"
                    @selected="changeSelectProjects"
                  />
                <!-- <span
                    v-if="errors[0]"
                    :class="$style.error"
                  >
                    {{ errors[0] }}
                  </span> -->
                </div>
                <div v-else>
                  <vgp-dropdown-select
                    ref="selectedProjects"
                    :placeholder="locale('reports_pages_projects_dropdown_placeholder')"
                    :class="[$style.vgp_select]"
                    :highlight-active-state="false"
                    :use-search="true"
                    :show-selected-first="true"
                    :show-reset-btn="false"
                    :selected="selectedMultiview"
                    :drop-list="multiviews"
                    item-template="text"
                    :multiselect="false"
                    track-by-text="name"
                    class="dropdown"
                    :size="'autoWidth'"
                    :need-description="false"
                    :popup-max-height="200"
                    @selected="changeSelectMultiview"
                  />
                  <!-- <span
                    v-if="errors[0]"
                    :class="$style.error"
                  >
                    {{ errors[0] }}
                  </span> -->
                </div>
              </template>
            </vgp-label-slot>
            <div
              v-if="isShowBaselineNotification"
              :style="{paddingTop: '16px'}"
            >
              <inline-notification
                type="warning"
                :text="warningMessage"
                :message-styles="{'font-size': '12px', 'white-space': 'normal'}"
              />
            </div>
          </div>

          <!-- VERSION WITH TABLE REPORTS -->
          <!-- <div :class="$style.report_form_element">
              <vgp-label-slot
                :label="locale(`report_representation`)"
              >
                <template #body>
                  <div
                    v-for="(option, index) in options"
                    :key="index"
                    :class="$style.radio_option"
                  >
                    <vgp-radio-button
                      :checked="option.selected"
                      :label="locale(`report_option_${option.text}_label`)"
                      @update:checked="selectOption($event, option)"
                    />
                  </div>
                </template>
              </vgp-label-slot>
            </div> -->
        </div>
        <div :class="[$style.form_line_buttons]">
          <vgp-button
            type="primary"
            :small="false"
            :label="locale('report_create_btn')"
            :disabled="disabledButton"
            @onClick="onClickSubmit"
          />
        </div>
      </template>
    </core-popup>
  </div>
</template>

<script>
import _ from 'lodash';
// import { defineRule, Form, Field } from 'vee-validate';
// import { required } from '@vee-validate/rules';
import app from '../../../app';
import VgpLabelSlot from '$$vueCmp/label/vgpLabelSlot.vue';
import corePopup from '$$vueCmp/popups/corePopup/corePopup.vue';
import VgpDropdownSelect from '$$vueCmp/dropdownSelect/dropdownSelect.vue';
import projectsModel from '$$projectModel';
import multiViewsProjects from '../../../models/multiViewsProjects';
import filters from '../../filter/filters/index';
import filterConstants from '../../filter/constants';
import constants from '../../../helpers/constants';
import inlineNotification from '../../common/VueComponents/nofitication/inline/InlineNotification.vue';
// import VgpRadioButton from '$$vueCmp/radioButton/vgpRadioButton.vue'; <--- VERSION WITH TABLE REPORTS
import rights from '../../../components/rights/index';
import reportHelpers from './helpers';

// defineRule('field_required', value => {
//   if (!required(value)) {
//     return __('error_required_field');
//   }

//   return true;
// });

const calculationItems = [
  {
    id: constants.OVERVIEW_TYPES.ACTUAL_TO_PLANNED,
    text: __(`overview_type_${constants.OVERVIEW_TYPES.ACTUAL_TO_PLANNED}`),
    group: __('report_calculation_group_actual_label'),
    disabled: false,
  },
  {
    id: constants.OVERVIEW_TYPES.ACTUAL_TO_BASELINE,
    text: __(`overview_type_${constants.OVERVIEW_TYPES.ACTUAL_TO_BASELINE}`),
    group: __('report_calculation_group_baseline_label'),
    disabled: false,
  },
  {
    id: constants.OVERVIEW_TYPES.PLANNED_TO_BASELINE,
    text: __(`overview_type_${constants.OVERVIEW_TYPES.PLANNED_TO_BASELINE}`),
    group: __('report_calculation_group_baseline_label'),
    disabled: false,
  },
];

export default {
  components: {
    // VgpRadioButton, <--- VERSION WITH TABLE REPORTS
    VgpDropdownSelect,
    corePopup,
    VgpLabelSlot,
    inlineNotification,
    // Form,
    // Field,
  },
  props: {
    title: { type: String, required: false, default: '' },
    showForm: { type: Boolean, required: true, default: false },
    routerName: { type: String, required: true, default: 'progressReports' }, // name of router in app/public/router/main.js
    chartType: { type: String, required: false, default: null },
    reportType: { type: String, required: false, default: null },
  },
  emits: [
    'onToggle',
  ],
  data() {
    return {
      locale: __,
      appListeners: [],
      tab_selected: 0,
      selectedProjects: [],
      selectedMultiview: [],
      projects: [],
      multiviews: [],
      activeFormTab: {
        id: 1,
        title: __('rpt_projects'),
        type: 'projects',
      },
      tabsItems: [
        {
          id: 1,
          title: __('rpt_projects'),
          type: 'projects',
        },
        {
          id: 2,
          title: __('rpt_multiview'),
          type: 'multiview',
        },
      ],
      chartMode: 'graphic', // graphic or table
      options: [{ id: 'graphic', selected: true, text: 'graphic' }, { id: 'table', selected: false, text: 'table' }],
      calculationMode: null,
      hasBaselines: true,
      isShowBaselineNotification: false,
      hasUserActivity: false,
    };
  },
  computed: {
    hasAccessToPortfolios() {
      return rights.account.hasRight('multiview_all_features');
    },
    dataProjects() {
      return projectsModel.getAllProjects();
    },
    hasPortfoliosTab() {
      if (!this.hasAccessToPortfolios) {
        return false;
      }

      if (this.chartType === 'month') {
        return false;
      }

      return true;
    },
    hasMultiSelect() {
      if (this.chartType === 'month') {
        return false;
      }

      if ([constants.OVERVIEW_TYPES.ACTUAL_TO_BASELINE, constants.OVERVIEW_TYPES.PLANNED_TO_BASELINE].includes(this.calculationMode?.id)) {
        return false;
      }

      return true;
    },
    calculationDropdownItems() {
      let items = [];
      const reportsWithProjects = ['schedule', 'project'];

      if (this.chartType === 'month') {
        items = calculationItems.map(item => {
          const prepared = { ...item };

          prepared.tooltip = {
            content: __(`reports_pages_calculation_model_tooltip_${item.id}_single_report`),
            placement: 'right',
          };
          delete prepared.group;

          return prepared;
        });
      }

      if (reportsWithProjects.includes(this.chartType)) {
        items = calculationItems.map(item => {
          const prepared = { ...item };

          prepared.tooltip = {
            content: __(`reports_pages_calculation_model_tooltip_${item.id}_multiple_report`),
            placement: 'right',
          };

          return prepared;
        });
      }

      items = items.map(item => ({
        ...item,
        disabled: [constants.OVERVIEW_TYPES.ACTUAL_TO_BASELINE, constants.OVERVIEW_TYPES.PLANNED_TO_BASELINE].includes(item.id)
        && (this.activeFormTab.type === 'multiview' || this.selectedProjects.length > 1),
      }));

      return items;
    },
    warningMessage() {
      if (this.selectedProjects?.length) {
        const projectData = projectsModel.getProjectDataById(this.selectedProjects[0].id);

        if (projectData) {
          const message = __('report_creation_form_project_baseline_notification', { projectName: projectData.name });

          return message;
        }
      }

      return '';
    },
    disabledButton() {
      return (!this.selectedProjects.length && !this.selectedMultiview.length) || this.isShowBaselineNotification;
    },
  },

  watch: {
    selectedProjects: {
      async handler(projects) {
        if (projects.length > 1) {
          this.calculationMode = this.calculationDropdownItems[0];
        }

        if (projects.length === 1 && this.calculationDropdownItems.length) {
          await this.checkBaselines(projects[0].id);
          this.showBaselineNotificationIfNedeed();
        }
      },
      deep: true,
    },
    selectedMultiview(multiviews) {
      if (multiviews.length) {
        this.calculationMode = this.calculationDropdownItems[0];
      }
    },
    showForm: {
      handler(flag) {
        const reportNameAnalytics = this.title.replace(/^exmp_chart_/, '').replace(/_title$/, '');

        if (flag) {
          userExtAnalytics.log('report_creation_modal_open', {
            report_category: this.reportType,
            report_type: reportNameAnalytics,
          });
        } else {
          userExtAnalytics.log('report_creation_modal_close', {
            report_type: reportNameAnalytics,
            was_filled: this.hasUserActivity,
          });
        }
      },
      immediate: true,
    },
  },

  mounted() {
    this.projects = projectsModel.getAllProjects();
    this.multiviews = multiViewsProjects.getAllMultiviews();
    this.calculationMode = this.calculationDropdownItems[0];
    this.initAppListeners();
  },

  beforeUnmount() {
    this.appListeners?.forEach(id => app.off(id));
    this.appListeners = [];
  },

  methods: {
    onClickSubmit: _.debounce(function () {
      this.submitForm();
    }, 1500, {
      leading: true,
    }),

    initAppListeners() {
      const onAfterCollaboration = app.on('onAfterCollaboration', event => {
        const projectEvents = ['ProjectRestored', 'ProjectArchived', 'ProjectDeleted', 'ProjectUpdated'];

        if (projectEvents.includes(event.event)) {
          this.projects = projectsModel.getAllProjects();

          const selectedProject = this.selectedProjects.find(pr => event.projects.includes(pr.id));

          if (selectedProject) {
            const index = this.selectedProjects.indexOf(selectedProject);
            const projectData = this.projects.find(pr => pr.id === selectedProject.id);

            if (projectData) {
              this.selectedProjects.splice(index, 1, projectData);
            } else {
              this.selectedProjects.splice(index, 1);
            }
          }
        }
      });

      this.appListeners.push(onAfterCollaboration);
    },

    async checkBaselines(projectId) {
      await this.$store.dispatch('baselines/fetchBaselines', projectId);

      const baselines = this.$store.getters['baselines/getProjectBaselines'](projectId);

      if (!baselines.length) {
        this.hasBaselines = false;
      } else {
        this.hasBaselines = true;
      }
    },

    toggleTab(tab) {
      if (tab.id === this.activeFormTab.id) return;

      userExtAnalytics.log('report_creation_modal_report_source_change', { calculation_mode: tab.type });

      this.selectedProjects = [];
      this.selectedMultiview = [];
      this.activeFormTab = tab;
      this.isShowBaselineNotification = false;
      this.calculationMode = this.calculationDropdownItems[0];
    },

    changeSelectProjects(data) {
      this.hasUserActivity = true;
      this.selectedProjects = data;
      this.selectedMultiview = [];
    },

    changeCalculationMode(data) {
      if (this.calculationMode.id === data[0].id) return;
      this.hasUserActivity = true;
      userExtAnalytics.log('report_creation_modal_calculation_mode_change', {
        calculation_mode: data[0].id,
      });

      const baselineCalculationModels = [constants.OVERVIEW_TYPES.ACTUAL_TO_BASELINE, constants.OVERVIEW_TYPES.PLANNED_TO_BASELINE];

      if (baselineCalculationModels.includes(data[0].id)) {
        this.activeFormTab = this.tabsItems[0];
        this.selectedMultiview = [];
      }

      if (this.selectedProjects.length > 1) {
        this.selectedProjects = [];
      }

      this.calculationMode = data[0];
      this.showBaselineNotificationIfNedeed();
    },

    showBaselineNotificationIfNedeed() {
      const baselineCalculationModels = [constants.OVERVIEW_TYPES.ACTUAL_TO_BASELINE, constants.OVERVIEW_TYPES.PLANNED_TO_BASELINE];
      const isShowNotification = this.selectedProjects.length && !this.hasBaselines && baselineCalculationModels.includes(this.calculationMode.id);

      if (isShowNotification) {
        this.isShowBaselineNotification = true;
      } else {
        this.isShowBaselineNotification = false;
      }
    },

    changeSelectMultiview(data) {
      this.hasUserActivity = true;
      this.selectedProjects = [];
      this.selectedMultiview = data;
    },

    toggleForm(type) {
      this.$emit('onToggle', type);
    },

    selectOption(event, item) {
      this.options.forEach(option => {
        option.selected = option.id === item.id;
        if (option.id === item.id) {
          this.chartMode = item.id;
        }
      });
    },

    async submitForm() {
      const params = {
        type: this.chartType,
        // mode: this.chartMode,
        // calculationMode: this.calculationMode,
        // sourceType: this.activeFormTab.type,
        // reportTitle: this.title,
      };
      const query = {
        userId: user.id,
      };

      // if (this.options.length) {
      //   query.mode = this.chartMode;
      // }

      if (this.calculationMode?.id) {
        query.calculationModel = this.calculationMode.id;
      }

      const filterTypes = {
        progressReports: 'reportsProgress',
        budgetReports: 'reportsBudget',
        timeReports: 'reportsTime',
      };

      const projectIds = this.selectedProjects.length ? this.selectedProjects.map(project => project.id) : '';
      const portfolioIds = this.selectedMultiview.length ? [this.selectedMultiview[0].id] : '';
      const needFilter = !['costslist', 'timeloglist'].includes(this.chartType);

      if (needFilter) {
        const filterType = filterTypes[this.routerName] + (this.chartType.charAt(0).toUpperCase() + this.chartType.slice(1));
        const filter = filters[filterType]();
        const sixMonthRange = [
          filterConstants.FILTERS.reportsProgressMonth,
          filterConstants.FILTERS.reportsBudgetMonth,
          filterConstants.FILTERS.reportsTimeMonth,
        ];
        const filtersWithBaselineSettings = [
          filterConstants.FILTERS.reportsBudgetProject,
          filterConstants.FILTERS.reportsTimeProject,
          filterConstants.FILTERS.reportsProgressSchedule,
        ];
        const baselineCalculationModels = [constants.OVERVIEW_TYPES.ACTUAL_TO_BASELINE, constants.OVERVIEW_TYPES.PLANNED_TO_BASELINE];

        let filterProperties = {};

        if (filter?.properties) {
          const hasGanttIdsProp = 'gantt_id' in filter.properties;
          const hasPortfolioIdsProp = 'portfolio_id' in filter.properties;
          const hasRangeDateProp = 'rangeDate' in filter.properties;

          filterProperties = {
            ...filter.properties,
          };

          if (hasGanttIdsProp) {
            filterProperties = {
              ...filterProperties,
              gantt_id: projectIds,
            };
          }

          if (hasPortfolioIdsProp) {
            filterProperties = {
              ...filterProperties,
              portfolio_id: portfolioIds,
            };
          }

          if (hasRangeDateProp) {
            const defaultRange = reportHelpers.defaultRange();
            let range = defaultRange.this_month;

            if (sixMonthRange.includes(filter.type)) {
              range = defaultRange.last_6_months;
            }

            filterProperties = {
              ...filterProperties,
              rangeDate: { ...range },
            };
          }
        }

        await this.$store.dispatch('filter/updateActiveFilter', {
          type: filter.type,
          properties: filterProperties,
        });

        if (filtersWithBaselineSettings.includes(filter.type) && baselineCalculationModels.includes(this.calculationMode.id)) {
          this.$store.commit('filter/updateAdvancedSettingsByFilterType', {
            type: filter.type,
            settings: { baselineEnabled: true },
          });
        }

        const reportNameAnalytics = this.title.replace(/^exmp_chart_/, '').replace(/_title$/, '');
        const analyticParams = {
          report_category: this.reportType,
          report_type: reportNameAnalytics,
          calculation_mode: this.calculationMode?.id || null,
          source_type: this.activeFormTab.type,
        };

        if (this.activeFormTab.type === 'projects') {
          analyticParams.projects_selected_count = this.selectedProjects.length;
        }

        if (this.activeFormTab.type === 'multiview') {
          analyticParams.portfolios_selected_count = this.selectedMultiview.length;
        }

        userExtAnalytics.log('report_click_create', analyticParams);
      }

      this.$router.push({
        name: this.routerName,
        params,
        query,
      });
    },
  },
};
</script>

<style module src='./../less/reportsMain.less'></style>
